<template>
  <body>
    <div class="header">
      <router-link to="/dl"><img src="@/assets/logo.svg"></router-link>
    </div>
    <div class="form">
      <div class="explain-box">
        <div class="text-box">
          <h2 class="catch-copy">HRモンスターで、<br>採用にワクワクを。</h2>
          <div class="detail">HRモンスターの資料ダウンロードページへようこそ。「資料ダウンロード」ボタンよりダウンロードができます。HRモンスターは、公式サイトを訪れる応募検討者にダイレクトにスカウトできる画期的な採用支援ツールです。採用ボットたちが動機付けやQA対応、また応募エントリーや面接の日程調整まで代行できる、採用専用のプラットフォームです。</div>
        </div>
        <div class="image-box">
          <img class="lp-img-01" src="@/assets/lp/lp_head_01.png">
          <img class="lp-img-02" src="@/assets/lp/lp_head_02.png">
        </div>
      </div>
      <div class="download-box">
        <a class="button is-rounded mobile-btn" :href="'https://storage.googleapis.com/hr-monster/HR%E3%83%A2%E3%83%B3%E3%82%B9%E3%82%BF%E3%83%BC%E3%83%8F%E3%82%9A%E3%83%B3%E3%83%95%E3%83%AC%E3%83%83%E3%83%88' + getCompany() + '.pdf'" download>
          <span class="mdi mdi-file-download" style="margin-right: 10px;"></span>資料ダウンロード
        </a>
      </div>
    </div>
  </body>
</template>

<script>
import getParam from '@/functions/getParam'
export default {
  name: 'Download',
  componentName: 'Download',
  created () {
    console.debug('*** Start *** created')
    this.$ga.page('/dl')
    console.debug('*** End *** created')
  },
  methods: {
    getCompany () {
      console.debug('*** Start *** getCompany')
      var param = getParam('type')
      if (param == undefined) return ''
      else if (param.length == 0) return ''
      else return '_' + param
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.header {
  background-color: #313E4D;
  height: 50px;
  color: white;
  font-size: 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.form {
  height: calc(100vh - 50px);
  width: 100vw;
  background: #f8f8f8;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  flex-direction: column;
}
.explain-box {
  width: 100%;
  height: 80%;
  padding: 20px;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
}
.text-box {
  width: 50%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex-direction: column;
  margin: 30px;
}
.download-box {
  height: 20%;
  width: 49%;
  padding: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.catch-copy {
  text-align: left;
  font-size: 28px;
  font-weight: 600;
  margin-bottom: 30px;
}
.image-box{
  position: relative;
  height: 80%;
  width: 50%;
}
.lp-img-01{
  position: absolute;
  width: 320px;
  top: 30px;
  left: 120px;
  z-index: 1;
  border: solid thin #ccc;
  border-top-left-radius: 30px;
  border-bottom-right-radius: 30px;
}
.lp-img-02{
  position: absolute;
  width: 320px;
  right: 150px;
  top: 220px;
  z-index: 0;
  border: solid thin #ccc;
  border-radius: 10px;
}
.mobile-btn {
  background-color: #22bb00;
  color:white;
  font-weight: 600;
  height: 64px;padding-left: 30px;padding-right: 30px;
}
.detail {
  text-align: left;
}
@media screen and (max-width: 1500px) {
  .lp-img-01{
    position: absolute;
    width: 320px;
    top: 30px;
    left: 100px;
    z-index: 1;
    border: solid thin #ccc;
    border-top-left-radius: 30px;
    border-bottom-right-radius: 30px;
  }
  .lp-img-02{
    position: absolute;
    width: 320px;
    right: 100px;
    top: 150px;
    z-index: 0;
    border: solid thin #ccc;
    border-radius: 10px;
  }
}
@media screen and (max-width: 1200px) {
  .lp-img-01{
    position: absolute;
    width: 320px;
    top: 30px;
    left: 20px;
    z-index: 1;
    border: solid thin #ccc;
    border-top-left-radius: 30px;
    border-bottom-right-radius: 30px;
  }
  .lp-img-02{
    position: absolute;
    width: 320px;
    right: 20px;
    top: 150px;
    z-index: 0;
    border: solid thin #ccc;
    border-radius: 10px;
  }
}
@media screen and (max-width: 1000px) {
  .lp-img-01{
    position: absolute;
    width: 320px;
    top: 0;
    left: 0;
    z-index: 1;
    border: solid thin #ccc;
    border-top-left-radius: 30px;
    border-bottom-right-radius: 30px;
  }
  .lp-img-02{
    position: absolute;
    width: 320px;
    right: 20px;
    top: 120px;
    z-index: 0;
    border: solid thin #ccc;
    border-radius: 10px;
  }
}
@media screen and (max-width: 800px) {
  .lp-img-01{
    position: absolute;
    width: 280px;
    top: 30px;
    left: 0;
    z-index: 1;
    border: solid thin #ccc;
    border-top-left-radius: 30px;
    border-bottom-right-radius: 30px;
  }
  .lp-img-02{
    position: absolute;
    width: 280px;
    right: 0;
    top: 100px;
    z-index: 0;
    border: solid thin #ccc;
    border-radius: 10px;
  }
}
@media screen and (max-width: 700px) {
  .form {
    height: calc(100vh - 50px);
    width: 100vw;
    background: #f8f8f8;
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    flex-direction: column;
  }
  .explain-box {
    width: 100%;
    height: 80%;
  }
  .download-box {
    width: 100%;
    height: 20%;
  }
  .lp-img-01{
    position: absolute;
    width: 220px;
    top: 30%;
    left: 0;
    z-index: 1;
    border: solid thin #ccc;
    border-top-left-radius: 30px;
    border-bottom-right-radius: 30px;
  }
  .lp-img-02{
    position: absolute;
    width: 220px;
    right: 10px;
    top: 40%;
    z-index: 0;
    border: solid thin #ccc;
    border-radius: 10px;
  }
}
@media screen and (max-width: 600px) {
  .form {
    height: calc(100vh - 50px);
    width: 100vw;
    background: #f8f8f8;
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    flex-direction: column;
    overflow-y: scroll;
  }
  .explain-box {
    width: 100%;
    height: 80%;
    padding-top: 10px;
    flex-direction: column;
  }
  .download-box{
    margin-top: 20px;
    width: 100%;
    height: 20%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: column;
  }
  .text-box {
    width: 90%;
    height: 50%;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    flex-direction: column;
    margin: 15px;
    margin-bottom: 10px;
  }
  .image-box{
    position: relative;
    margin-top:15px;
    height: 50%;
    width: 50%;
  }
  .catch-copy {
    font-size: 18px;
    margin-bottom: 10px;
  }
  .mobile-btn {
    height: 48px;padding-left: 30px;padding-right: 30px;margin-top:10px;
  }
  .detail {
    font-size: 12px;
  }
  .lp-img-01{
    position: absolute;
    width: 280px;
    top: 0;
    left: -40px;
    z-index: 1;
    border: solid thin #ccc;
    border-top-left-radius: 30px;
    border-bottom-right-radius: 30px;
  }
  .lp-img-02{
    position: absolute;
    width: 280px;
    right: -40px;
    top: 30px;
    z-index: 0;
    border: solid thin #ccc;
    border-radius: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Download/Download.vue